import Vue from "vue";
import App from "./App.vue";
import router from "./router";

import Buefy from "buefy";
import "buefy/dist/buefy.css";
// https://buefy.github.io/documentation/constructor-options/
//Vue.use(Buefy)

//import DisableAutocomplete from 'vue-disable-autocomplete';
//Vue.use(DisableAutocomplete); // BUG: setta il readonly quindi non si può scrivere sui dropdown lol

// CURRENCY INPUT
import VueCurrencyInput from 'vue-currency-input'
// https://dm4t2.github.io/vue-currency-input/config/#component
const vueConcurrencyOptions = {
  globalOptions: { currency: 'EUR', locale:'de', precision: 2, allowNegative: false, valueRange: { min: 0, max : 100 } }
}
Vue.use(VueCurrencyInput, vueConcurrencyOptions)

import moment from "moment";
const dateformat = "DD/MM/YYYY"; // DD/MM/YYYY
const datetimeformat = "DD/MM/YYYY hh:mm"; // DD/MM/YYYY

Vue.use(Buefy, {
  defaultIconPack: "fa",
  defaultDateFormatter: date => moment(date).format(dateformat),
  defaultMonthNames: [
    "Gennaio",
    "Febbraio",
    "Marzo",
    "Aprile",
    "Maggio",
    "Giugno",
    "Luglio",
    "Agosto",
    "Settembre",
    "Ottobre",
    "Novembre",
    "Dicembre"
  ],
  defaultDayNames: ["DO", "LU", "MA", "ME", "GI", "VE", "SA"],
  defaultFirstDayOfWeek: 1
});

/******* FILTERS ********/
Vue.filter("date", function (date) {
  return moment(date).format(dateformat);
});

Vue.filter("datetime", function (date) {
  return moment(date).format(datetimeformat);
});

Vue.filter("truncate", function (text, clamp) {
  return text.length > clamp ? text.substring(0, clamp) + "…" : text;
});

Vue.filter("rescale", function (num, digits, offset = 1) {
  num = num * offset;

  var si = [
    /*
    {
      value: 1e-3,
      symbol: "m"
    },*/
    {
      value: 1,
      symbol: ""
    },
    {
      value: 1e3,
      symbol: "K"
    },
    {
      value: 1e6,
      symbol: "M"
    },
    {
      value: 1e9,
      symbol: "G"
    },
    {
      value: 1e12,
      symbol: "T"
    },
    {
      value: 1e15,
      symbol: "P"
    },
    {
      value: 1e18,
      symbol: "E"
    }
  ];
  var rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
  var i;
  for (i = si.length - 1; i > 0; i--) {
    if (num >= si[i].value) {
      break;
    }
  }

  const r =
    (num / si[i].value).toFixed(digits).replace(rx, "$1") + si[i].symbol;
  return r;
});

/******* DIRECTIVES ********/
Vue.directive("uppercase", {
  twoWay: true,
  // TODO: unbind
  unbind: () => {},
  bind: function (el, binding, vnode) {
    const findVModelName = vnode => {
      try {
        // https://forum.vuejs.org/t/solved-how-can-you-update-the-v-model-from-a-custom-directive-in-vue-2/2275
        return vnode.data.directives.find(o => {
          return o.name === "model";
        }).expression;
      } catch (error) {
        error.message = `Unable to find v-model directive at ${
          vnode.tag
        } tag. Please specify the expression: v-uppercase='obj.prop'`;
        throw error;
      }
    };

    const funcByName = (functionName, context, value) => {
      // https://stackoverflow.com/a/359910/8801075
      var namespaces = functionName.split(".");
      var func = namespaces.pop();
      for (var i = 0; i < namespaces.length; i++)
        context = context[namespaces[i]];
      return (context[func] = value);
    };

    var expression = binding.expression ?
      binding.expression :
      findVModelName(vnode);
    vnode.context.$watch(expression, {
      //deep: true,
      immediate: true,
      handler(newVal) {
        if (newVal) {
          // TODO: fai node traveling per scovare l'el textarea/input
          return funcByName(
            expression,
            vnode.context,
            newVal.toString().toLocaleUpperCase()
          );
        }
      }
    });
  }
});

/* if no promises: https://vuex.vuejs.org/installation.html

import Vuex from 'vuex'
Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    users: {},
    count: 0
  },
  mutations: {
    increment(state) {
      state.count++
    }
  }
})
 */

import AjaxHelper from "./plugins/ajaxhelper";
Vue.use(AjaxHelper, {
  baseURL: process.env.VUE_APP_API_ENDPOINT
});

//import userHelper from "./plugins/userhelper"
//Vue.use(userHelper);

import "./styles/style.css";

Vue.config.productionTip = false;

new Vue({
  router,
  data: {
    currentRoute: window.location.pathname
  },
  render: h => h(App)
}).$mount("#app");